<template>
  <div class="page-container">
    <Table ref="tableRef" :params="params" :request="getData" tooltip-effect="light">
      <template #search="{query}">
        <el-form-item>
          <el-button type="primary" plain @click="exportData(query)">{{ $t('activity.packetjoin.export') }}</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px;" :label="$t('activity.packetjoin.pendingAmt')">{{notSendAmount}}{{ $t('activity.packetjoin.yuan') }}</el-form-item>
      </template>
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <!-- <el-table-column prop="name" label="活动名称" /> -->
      <el-table-column prop="activityType" :label="$t('activity.list.actType')" >
        <template #default="{row}">{{activityTypeMap[row.activityType]}}</template>
      </el-table-column>
      <el-table-column prop="userId" :label="$t('activity.packetjoin.userId')" />
      <el-table-column prop="joinTime" :label="$t('activity.packetjoin.participationTime')" sortable="custom" />
      <el-table-column prop="userName" :label="$t('activity.packetjoin.userName')" />
      <el-table-column prop="userPhone" :label="$t('activity.packetjoin.phone')" >  
        <template #default="{row}">
          {{ row.userPhone &&  (String(row.userPhone).slice(0,3)+'****'+String(row.userPhone).slice(7))}}
        </template>
      </el-table-column>
      <el-table-column prop="redAmount" :label="$t('activity.packetjoin.redPacketAmt')" />
      <el-table-column prop="orderNo" :label="$t('activity.packetjoin.paymentSerial')" />
      <el-table-column prop="redEnvelope" :label="$t('activity.packetjoin.distributionStatus')" >
        <template #default="{row}">{{ packetStatusMap[row.redEnvelope] }}</template>
      </el-table-column>
      <!-- <el-table-column prop="company" label="公司" /> -->
      <!-- <el-table-column prop="companyApplication" label="应用公司" /> -->
      <el-table-column prop="activityContent" :label="$t('activity.packetjoin.participationContent')" >
        <template #default="{row}" >
          <el-button v-if="row.verifyStatus !== 3" type="text" plain size="mini" @click="packetDetail(row)">{{ $t('activity.packetjoin.details') }}</el-button>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="" label="点赞/收藏/评论" /> -->
      <el-table-column prop="robotNum" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column prop="applicationType" :label="$t('activity.packetjoin.appType')" />

      <el-table-column prop="isOpen" :label="$t('activity.packetjoin.publicOrNot')" >
        <template #default="{row}">{{ row.isOpen? $t('activity.packetjoin.private') : $t('activity.packetjoin.public') }}</template>
      </el-table-column>
      <el-table-column prop="verifyContext" :label="$t('activity.packetjoin.approvalComments')" />
      <el-table-column prop="verifyStatus" :label="$t('activity.packetjoin.approvalStatus')" >
        <template #default="{row}">{{ verifyStatusMap[row.verifyStatus] }}</template>
      </el-table-column>
      <el-table-column prop="verifyUser" :label="$t('activity.packetjoin.approver')" />
      <el-table-column :label="$t('activity.list.operation')"  width="220" fixed="right">
        <template #default="{row}">
          <el-button v-if="!row.verifyStatus" type="text" size="mini" @click="packetApprove(row)">{{ $t('activity.packetjoin.approve') }}</el-button>
          <el-button v-if="!row.verifyStatus" type="text" style="color: #e6a23c;" size="mini" @click="packetReject(row)">{{ $t('activity.packetjoin.reject') }}</el-button>
          <el-button v-if="!row.verifyStatus" type="text" style="color: #f56c6c;" size="mini" @click="packetDelete(row)">{{ $t('activity.packetjoin.delete') }}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog v-model="dialogDataVisible" top="5vh" width="75%" :title="$t('activity.packetjoin.details')" destroy-on-close :modal="true" :append-to-body="true">
      <el-form class="dialog-form" label-width="120px">
        <el-form-item class="list-item" :label="$t('activity.list.time')">
          <div>{{ detailData.joinTime }}</div>
        </el-form-item>
        <el-form-item class="list-item" :label="$t('activity.packetjoin.name')">
          <div>{{ detailData.userName }}</div>
        </el-form-item>
        <el-form-item class="list-item" :label="$t('activity.packetjoin.content')">
          <div class="form-textarea">
            {{ detailData.activityContent }}
          </div>
        </el-form-item>
        <el-form-item class="list-item" :label="$t('activity.packetjoin.preLaunchMedia')">
          <template
            v-for="(file, index) in (detailData.activityFileFront||'').split(',')"
            :key="index"
          >
            <video v-if="file && file.includes('.mp4')" class="el-video-inline" controls>
              <source :src="file" />
            </video>
            <el-image
              v-else-if="file"
              class="el-image-inline"
              :src="file"
              :preview-src-list="(detailData.activityFileFront||'').split(',')"
            >
            </el-image>
          </template>
        </el-form-item>
        <el-form-item class="list-item" :label="$t('activity.packetjoin.postLaunchMedia')">
          <template
            v-for="(file, index) in (detailData.activityFileAfter||'').split(',')"
            :key="index"
          >
            <video v-if="file && file.includes('.mp4')" class="el-video-inline" controls>
              <source :src="file" />
            </video>
            <el-image
              v-else-if="file"
              class="el-image-inline"
              :src="file"
              :preview-src-list="(detailData.activityFileAfter||'').split(',')"
            >
            </el-image>
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, toRefs } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import Table from "@/components/elp/table";

import { request, downloadFile } from "@/utils/request";
import { common } from "@/common/mixin";
import { verifyStatusList, verifyStatusMap, packetStatusList, packetStatusMap } from "@/common/constant"
import { onMounted } from '@vue/runtime-core';
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const activityTypeList = [
      { name: t('activity.detail.newProduct'), value: 0 },
      { name: t('activity.packetjoin.registerRedPacket'), value: 1 },
    ]
    const activityTypeMap = {
      0: t('activity.detail.newProduct'),
      1: t('activity.packetjoin.registerRedPacket')
    }
    const state = reactive({
      tableRef: null,
      params: [
        {
          type: "Input",
          key: "userName",
          value: "",
          label: t('activity.packetjoin.recipient'),
        },
        {
          type: "Input",
          key: "userPhone",
          value: "",
          label: t('activity.packetjoin.phone'),
        },
        {
          type: "Select",
          key: "activityType",
          value: "",
          label: t('activity.list.actType'),
          options: {
            data: activityTypeList,
            label: "name",
            value: "value"
          }
        },
        {
          type: "Input",
          key: "robotNum",
          value: "",
          label: t('activity.packetjoin.robotCode'),
        },
        {
          type: "Select",
          key: "verifyStatus",
          value: "",
          label: t('activity.packetjoin.approvalStatus'),
          options: {
            data: verifyStatusList,
            label: "name",
            value: "value"
          }
        },
        {
          type: "Select",
          key: "redEnvelope",
          value: "",
          label: t('activity.packetjoin.distributionStatus'),
          options: {
            data: packetStatusList,
            label: "name",
            value: "value"
          }
        },
        {
          type: "Date",
          key: "dateRange",
          value: [],
          label: t('activity.packetjoin.participationTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
      ],
      dialogDataVisible: false,
      detailData: {},
      activityType: activityTypeList, // 活动类型列表
      notSendAmount: ''
    })
    const getData = (params) => {
      const query = {
        pageNum: params.page,
        pageSize: params.size,
      }
      if (params.dateRange?.length) {
        query.startDate = params.dateRange[0]
        query.endDate = params.dateRange[1]
      } else {
        query.startDate = undefined
        query.endDate = undefined
      }
      return request("packetJoinList", Object.assign(query, params))
    };
    const getRedAmountCount = async () => {
      try {
        state.notSendAmount = await request("getRedAmountCount", {});
      } catch (error) {
        console.error(error);
      }
    }
    const packetDetail = (row) => {
      state.dialogDataVisible = true
      state.detailData = row
    }
    const exportData = async (params={}) => {
      try {
        const query = { ...params }
        if (params.dateRange?.length) {
          query.startDate = params.dateRange[0]
          query.endDate = params.dateRange[1]
        } else {
          query.startDate = undefined
          query.endDate = undefined
        }
        const res = await downloadFile("exportPacketJoin", {}, {
          method: 'GET',
          params: query
        });
        // let blob = new Blob([res],{type: "application/octet-stream"})
        let reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = t('activity.packetjoin.participationRecord')
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    }
    const packetApprove = async (row) => {
      try {
        await ElMessageBox.confirm(t('activity.packetjoin.approved'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          type: 'success',
        })
        // const { value } = await ElMessageBox.prompt(`请输入审批意见`, {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   inputValue: '',
        //   inputType: 'text',
        //   inputPattern: /^[^\s]+$/,
        //   inputErrorMessage: '输入无效'
        // })
        
        await request("packetApprove", {
          id: row.id
        });
        const imgList = []
        const video = []
        // if (row.activityFileFront?.includes('.mp4')) {
        //   video.push(row.activityFileFront)
        // } else if (row.activityFileFront) {
        //   imgList.push(...row.activityFileFront.split(','))
        // }
        if (row.activityFileAfter?.includes('.mp4')) {
          video.push(row.activityFileAfter)
        } else if (row.activityFileAfter) {
          imgList.push(...row.activityFileAfter.split(','))
        }
        // 公开 添加到技术论坛
        !row.isOpen && await request("addForum", {
          userId: row.userId,
          title: row.applicationType,
          content: row.activityContent,
          attachments: imgList.join(',') + ';;' + video.join(','),
          postType: 0
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
        state.tableRef?.update()
      } catch (error) {
        console.error(error);
      }
    }
    const packetReject = async (row) => {
      try {
        const { value } = await ElMessageBox.prompt(t('activity.packetjoin.enterApproval'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          // inputValue: '',
          inputType: 'text',
          inputPattern: /^[^\s]+$/,
          inputErrorMessage: t('activity.packetjoin.invalidInput')
        })

        await request("packetReject", {
          id: row.id,
          verifyContext: value
        });
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
        state.tableRef?.update()
      } catch (error) {
        console.error(error);
      }
    }
    
    const packetDelete = async (row) => {
      try {
        await ElMessageBox.confirm(t('activity.list.confirmDelete'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          type: 'warning',
        })
        await request("packetDelete", {
          id: row.id,
        });
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
        state.tableRef?.update()
      } catch (error) {
        console.error(error);
      }
    }

    onMounted(() => {
      getRedAmountCount()
    })
    return {
      verifyStatusMap,
      activityTypeMap,
      packetStatusMap,
      ...toRefs(state),
      getData,
      exportData,
      packetDetail,
      packetApprove,
      packetReject,
      packetDelete
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.list-item {
  margin-bottom: 0;
  text-align: left;
}
</style>
